<template>
  <div>
    <g-dialog-root />
    <router-view />
  </div>
</template>

<script>
import { GDialogRoot } from 'gitart-vue-dialog'

export default {
  components: {
    GDialogRoot,
  },
  async created() {
    await this.$store.dispatch('session/fetchSysHref')
    await this.$store.dispatch('session/refreshUser')
    if (this.$store.getters['session/getAuthStatus']) {
      this.$store.dispatch('bookmarks/loadBookmarksCount')
    }
  },
}
</script>

<style></style>
